module.exports = __webpack_public_path__ + "static/media/cockroach(13).2b0ce7cb.PNG";